<template>
  <div class="db-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-content">
            <el-form size="small" ref="editForm" :inline="true" :model="editForm" :rules="editRules" label-width="80px">
              <el-form-item label="操作人">
                <el-input v-model="user.dName" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="当前工序">
                <el-input v-model="editForm.process" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="包装类型" prop="ptid" @change="setPt">
                <el-select v-model="editForm.ptid">
                  <el-option
                    v-for="item in packtypeList"
                    v-if="item.dBrand===0||group.dBrand===0||group.dBrand===item.dBrand"
                    :key="item.dPtid"
                    :label="item.dName"
                    :value="item.dPtid">
                  </el-option>
                </el-select>
              </el-form-item>
              <br>
              <el-form-item label="部件条码" prop="bar">
                <el-input v-model="editForm.bar" ref="bar" style="width: 300px" placeholder="请输入部件条码或扫描部件二维码" maxlength="20" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="addData" :loading="fullscreenLoading" icon="el-icon-plus">添加部件</el-button>
                <el-button type="primary" :loading="loading" @click="subPack" icon="el-icon-box">立即打包</el-button>
              </el-form-item>
              <div style="font-size: 12px;color:#99a9bf;padding-left: 20px">
                <i class="el-icon-warning-outline"></i> 温馨提示：如果使用扫描器扫描没有反应，请<el-button @click="calibration" style="font-size: 12px" type="text">点击这里</el-button>！
              </div>
            </el-form>
            <el-card shadow="never" style="margin-top: 10px">
              <el-table
                size="small"
                stripe
                :data="tableData"
                style="width: 100%">
                <el-table-column label="条码" prop="barCode" width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="单号" prop="productNum" width="110" show-overflow-tooltip></el-table-column>
                <el-table-column label="序号" prop="xuhao" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="区域" prop="area" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="分类" prop="type" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="名称" prop="name" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="颜色" prop="color" width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="高/长" prop="high" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="宽" prop="width" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="L宽" prop="lwidth" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="厚" prop="ply" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column
                  label="操作"
                  fixed="right"
                  width="100">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="delData(scope.row)" icon="el-icon-delete">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpPacktypelist, getUnitByBarcode, unpackUnit, getGroupInfoByUser } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'db',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      group: {
        dBrand: 1
      },
      packtypeList: [],
      tableData: [],
      orderid: '',
      editForm: {
        bar: '',
        process: '包装',
        ptid: null
      },
      editRules: {
        bar: [{ required: true, message: '请输入部件条码', trigger: 'blur' }],
        ptid: [{ required: true, message: '请选择包装类型', trigger: 'change' }]
      }
    }
  },
  created() {
    this.fullscreenLoading = true
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    getErpPacktypelist().then(response => {
      this.packtypeList = response.data
      this.fullscreenLoading = false
      this.$refs.editForm.clearValidate()
      this.$refs.bar.focus()
    }).catch(() => {
      this.fullscreenLoading = false
      this.$refs.editForm.clearValidate()
      this.$refs.bar.focus()
    })
    let keycode = ''
    let lastTime = null
    let nextTime = null
    let lastCode = null
    let nextCode = null
    const _this = this
    setTimeout(document.onkeydown = function(e) {
      if (window.event) {
        nextCode = e.keyCode // IE
      } else if (e.which) {
        nextCode = e.which // Netscape/Firefox/Opera
      }
      if ((nextCode >= 48 && nextCode <= 57) || (nextCode >= 96 && nextCode <= 105)) {
        // 数字键盘的键码值对应的字符有问题，所以手动调整键码值
        const codes = { '48': 48, '49': 49, '50': 50, '51': 51, '52': 52, '53': 53, '54': 54, '55': 55, '56': 56, '57': 57,
          '96': 48, '97': 49, '98': 50, '99': 51, '100': 52, '101': 53, '102': 54, '103': 55, '104': 56, '105': 57
        }
        nextCode = codes[nextCode]
        nextTime = new Date().getTime()
        if (lastCode === null && lastTime === null) {
          keycode = String.fromCharCode(nextCode)
        } else if (lastCode !== null && lastTime !== null && nextTime - lastTime <= 30) {
          keycode += String.fromCharCode(nextCode)
        } else {
          keycode = ''
          lastCode = null
          lastTime = null
        }
        lastCode = nextCode
        lastTime = nextTime
      } else if (nextCode === 13 && keycode !== '') {
        _this.editForm.bar = keycode
        _this.addData()
        keycode = ''
        lastCode = null
        lastTime = null
      } else if (nextCode === 13) {
        _this.addData()
      } else if (keycode.length === 14) {
        _this.editForm.bar = keycode
        _this.addData()
        keycode = ''
        lastCode = null
        lastTime = null
      }
    }, 100)
  },
  methods: {
    setPt() {
      this.$refs.editForm.clearValidate()
      this.$refs.bar.focus()
    },
    calibration() {
      this.$message({
        message: '初始成功，可以开始扫描啦~',
        type: 'success'
      })
      this.$refs.editForm.clearValidate()
      this.$refs.bar.focus()
    },
    addData() {
      if (!this.fullscreenLoading) {
        this.$refs.editForm.validateField('bar', errMsg => {
          if (!errMsg) {
            let ishave = false
            for (let d of this.tableData) {
              if (d.barCode === this.editForm.bar) {
                ishave = true
                break
              }
            }
            if (!ishave) {
              this.fullscreenLoading = true
              getUnitByBarcode({ code: this.editForm.bar }).then(response => {
                if (response.data.mmark === 0) {
                  if (this.orderid !== '' && this.orderid !== null && this.orderid !== undefined) {
                    if (this.orderid === response.data.orderid) {
                      let datajson = []
                      datajson.push(response.data)
                      for (let olddata of this.tableData) {
                        datajson.push(olddata)
                      }
                      this.tableData = datajson
                    } else {
                      this.$message.error('该部件所属“' + response.data.productNum + '"”的部件，无法共同打包')
                    }
                  } else {
                    this.orderid = response.data.orderid
                    this.tableData.push(response.data)
                  }
                } else {
                  this.$message({
                    message: '部件 “' + response.data.barCode + '” 已打包',
                    type: 'warning'
                  })
                }
                this.fullscreenLoading = false
                this.editForm.bar = ''
                this.$refs.editForm.clearValidate()
                this.$refs.bar.focus()
              }).catch(() => {
                this.fullscreenLoading = false
                this.$refs.editForm.clearValidate()
                this.$refs.bar.focus()
              })
            } else {
              this.editForm.bar = ''
              this.$refs.editForm.clearValidate()
              this.$refs.bar.focus()
            }
          }
        })
      }
    },
    delData(row) {
      this.$confirm('此操作将删除 “' + row.barCode + '” 部件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (let i = 0; i < this.tableData.length; i++) {
          if (row.mdid === this.tableData[i].mdid) {
            this.tableData.splice(i, 1)
            break
          }
        }
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        if (this.tableData.length <= 0) {
          this.orderid = ''
        }
        this.$refs.editForm.clearValidate()
        this.$refs.bar.focus()
      }).catch(() => {
        this.$refs.editForm.clearValidate()
        this.$refs.bar.focus()
      })
    },
    subPack() {
      if (!this.loading) {
        this.$refs.editForm.clearValidate()
        this.$refs.editForm.validateField('ptid', errMsg => {
          if (!errMsg) {
            if (this.tableData.length > 0) {
              this.$confirm('确认打包此 ' + this.tableData.length + ' 项部件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let unitIds = []
                for (let m of this.tableData) {
                  unitIds.push(m.barCode)
                }
                this.loading = true
                const data = {
                  orderid: this.orderid,
                  userid: this.user.dUserid,
                  unitIds: unitIds.join(','),
                  ptid: this.editForm.ptid,
                  groupid: this.user.dGroupid
                }
                unpackUnit(data).then(response => {
                  this.tableData = []
                  this.orderid = ''
                  // this.editForm.ptid = null
                  this.loading = false
                  this.$message({
                    message: '打包成功',
                    type: 'success'
                  })
                  this.$refs.editForm.clearValidate()
                  this.$refs.bar.focus()
                  let LODOP = getLodop()
                  LODOP.PRINT_INIT('包装打印')
                  LODOP.SET_PRINT_PAGESIZE(1, '100mm', '100mm', '')
                  LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
                  for (let pack of response.data) {
                    LODOP.NewPageA()
                    LODOP.ADD_PRINT_HTM('2mm', '4mm', '100%', '100%', pack)
                  }
                  LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 500)
                  // LODOP.PREVIEW()
                  LODOP.PRINT()
                }).catch(() => {
                  this.loading = false
                  this.$refs.editForm.clearValidate()
                  this.$refs.bar.focus()
                })
              }).catch(() => {
                this.$refs.editForm.clearValidate()
                this.$refs.bar.focus()
              })
            } else {
              this.$message.error('至少打包一个部件')
              this.$refs.editForm.clearValidate()
              this.$refs.bar.focus()
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.db-container {

}
</style>
